const API_URL = '';

export const sendContactUsEmail = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/send/contact_us`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Neznámá chyba' }));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Chyba při odesílání emailu:', error);
    throw error;
  }
}